import ERRORS from './error'
import { convertNumber, numberRound } from './_utils'
import { SOCIAL_SECURITY_ROUND } from './privates'
export const MATH_HELPER = {
  ABS: {
    title: '绝对值',
    usage: 'ABS(数字)',
    desc: '获取数字绝对值',
    example: 'ABS(-3.14) => 3.14'
  },
  INT: {
    title: '求整',
    usage: 'INT(数字)',
    desc: '获取数字向下取整的数',
    example: 'INT(3.14) => 3; INT(-3.14) => -4'
  },
  MAX: {
    title: '最大值',
    usage: 'MAX(数值1,数值2...)',
    desc: '获取数字组中最大值',
    example: 'MAX(10,20,30,40) => 40，40为数字组中的最大值'
  },
  MIN: {
    title: '最小值',
    usage: 'MIN(数值1,数值2...)',
    desc: '获取数字组中最小值',
    example: 'MIN(10,20,30,40) => 10，10为数字组中的最小值'
  },
  MOD: {
    title: '求余',
    usage: 'MOD(被除数,除数)',
    desc: '获取余数',
    example: 'MOD(5,2) => 1'
  },
  UPPERMONEY: {
    title: '数字转中文',
    usage: 'UPPERMONEY(数字)',
    desc: '将数字转换为中文大写金额（单位精确到“分”）',
    example: 'UPPERMONEY(1234.1234)=> 壹仟贰佰叁拾肆元壹角贰分'
  },
  ROUND: {
    title: '四舍五入',
    usage: 'ROUND(数字,指定小数位数)',
    desc: '将数字四舍五入到指定位数',
    example: 'ROUND(3.1415,2) => 3.14; ROUND(3.14159,4) => 3.1416'
  },
  AVG: {
    title: '平均值',
    usage: 'AVG(数值1,数值2...)',
    desc: '获取数字组中的平均值（字段必须为数字字段）',
    example: 'AVG(10,20,30,40) => 25, 25为平均数值'
  },
  SUM: {
    title: '求和',
    usage: 'SUM(数字1,数字2...)',
    desc: '获取数字组参数的总和（字段必须为数字字段或金额字段）',
    example: 'SUM(金额,计提金额)'
  },
  NUMBER: {
    title: '转数字',
    usage: 'NUMBER(文本/日期)',
    desc: '将参数转换为数字的方式输出',
    example: 'NUMBER("123") => 123; NUMBER(IF(TRUE(),"-1","0"))+5 => 4'
  },
  MONEYFORMAT: {
    title: '金额格式化',
    usage: 'MONEYFORMAT(金额数值,格式化类型)',
    desc: '将金额数值转换为指定格式, 格式化类型： "1"-四舍五入到分; "2"-四舍五入到角; "3"-四舍五入到元; "4"-见角进分; "5"-见分舍去，见角进元; "6"-见厘进分; "7"-见角舍去; "8"-见厘舍去; "9"-四舍五入到厘; "10"-四舍五入保留4位小数;',
    example: 'MONEYFORMAT(3.1415926, 10) => 3.1416; MONEYFORMAT(3.1415926, 3.142) => 4'
  }
}

export const ABS = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('ABS', 1, args.length)
  return Math.abs(convertNumber(args[0]))
}

export const INT = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('INT', 1, args.length)
  return Math.floor(convertNumber(args[0]))
}

export const MAX = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('MAX', 2, args.length, false)
  return Math.max(...args.map((n) => convertNumber(n)))
}

export const MIN = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('MIN', 2, args.length, false)
  return Math.min(...args.map((n) => convertNumber(n)))
}

export const MOD = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('MOD', 2, args.length)
  return convertNumber(args[0]) % convertNumber(args[1])
}

export const UPPERMONEY = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('UPPERMONEY', 1, args.length)
  const [sourceNum] = args,
    isNegative = convertNumber(sourceNum) < 0

  let tempArr = ('' + sourceNum).replace('-', '').split('.', 2),
    integer = tempArr[0],
    decimal = tempArr[1],
    ret = [],
    hasNonZero = false

  const chineseNum = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'],
    chineseUint = [
      '元',
      '万',
      '亿',
      '兆',
      '京',
      '垓',
      '秭',
      '穣',
      '沟',
      '涧',
      '正',
      '版载',
      '极',
      '恒河沙',
      '阿僧只',
      '那由他',
      '不可思议',
      '无量',
      '大数'
    ]

  integer = integer.split('').reverse().join('')

  for (let i = 0; i < integer.length; i++) {
    let num = integer[i]
    let mod = i % 4

    if (mod === 0) {
      if (chineseUint.indexOf(ret[0]) >= 1) ret.shift()

      ret.unshift(chineseUint[Math.floor(i / 4)])
      hasNonZero = false
    }

    if (num === '0') {
      if (ret[0] !== '零' && hasNonZero) ret.unshift('零')
      continue
    }

    if (mod >= 1) ret.unshift(['', '拾', '佰', '仟'][mod])

    hasNonZero = true
    ret.unshift(chineseNum[+num])
  }

  if (!decimal || decimal.length === 0 || +decimal - 0 === 0) {
    ret.push('整')
  } else {
    ret.push(chineseNum[+decimal[0]])
    if (decimal[0] !== '0') ret.push('角')
    if (decimal[1] && decimal[1] !== '0') ret.push(chineseNum[+decimal[1]] + '分')
  }
  if (ret[0] === '元') ret.unshift('零')
  if (isNegative) ret.unshift('负')

  return ret.join('')
}

export const ROUND = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('ROUND', 1, args.length)
  return numberRound(convertNumber(args[0]), convertNumber(args[1]))
}

export const AVG = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('AVG', 2, args.length, false)
  return SUM(...args) / args.length
}

export const SUM = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('SUM', 2, args.length, false)
  return args.reduce((prev, cur) => convertNumber(prev) + convertNumber(cur))
}

export const NUMBER = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('NUMBER', 1, args.length)
  return convertNumber(args[0])
}

export const MONEYFORMAT = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('MONEYFORMAT', 2, args.length, false)
  return SOCIAL_SECURITY_ROUND(convertNumber(args[0]), convertNumber(args[1]))
}
